'use strict';
angular.module('televisionDistributionConfigurationModule', [])
    .controller('televisionDistributionConfigurationCtrl', [function() {
        initStatus();
        initData();

        function initStatus() {}

        function initData() {}
    }]);